export default __webpack_public_path__ + "static/O0053-4c396b98470c2d4ba7ee8f4a09e1a6a9.png";